<template>
	<div class="multi-format-aspect-ratio-selector">
		<div
			class="multi-format-aspect-ratio-selector__options"
			:aria-label="$I18n.trans_choice('spotlight.graphics.format', 1)"
		>
			<button
				v-for="option in options"
				:key="option.value"
				type="button"
				class="multi-format-aspect-ratio-selector__button"
				:class="{ 'is-active': option.value === value }"
				:disabled="disabled"
				@click="$emit('change', option.value)"
			>
				{{ option.label }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	name:  'MultiFormatAspectRatioSelector',
	props: {
		value: {
			type:    String,
			default: null,
		},
		options: {
			type:    Array,
			default: () => [],
		},
		disabled: {
			type:    Boolean,
			default: false,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.multi-format-aspect-ratio-selector {
	width: 100%;
}

.multi-format-aspect-ratio-selector__options {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	gap: $sp3;
}

.multi-format-aspect-ratio-selector__button {
	@include font-size(fs-80);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	min-width: 62px;
	height: 42px;
	padding: 0 $sp3;
	border: 1px solid var(--color-grey-600);
	border-radius: $border-radius--sm;
	color: var(--color-white);
	background-color: rgba($color-white, 0.04);
	cursor: pointer;
	transition: border-color $trans-time-fast, background-color $trans-time-fast, color $trans-time-fast;

	&:hover,
	&:focus {
		border-color: var(--color-grey-400);
		background-color: rgba($color-white, 0.08);
	}

	&.is-active {
		border-color: var(--color-hype-yellow);
		background-color: rgba($color-hype-yellow, 0.12);
	}

	// stylelint-disable selector-max-type, selector-no-qualifying-type
	body.-t-light & {
		color: var(--color-black);
		background-color: var(--color-grey-100);

		&:hover,
		&:focus {
			border-color: var(--color-grey-700);
			background-color: var(--color-white);
		}
	}
	// stylelint-enable selector-max-type, selector-no-qualifying-type

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
}
</style>
